import { Box, Stack, Typography, useTheme } from '@mui/material'
import { isEmpty } from 'lodash'
import { useState } from 'react'

type Props = {
  items: LegendItem[]
  onChange: (legend: LegendItem) => any
  label?: string
}

export const Legend = ({ items, label, onChange }: Props) => {
  if (isEmpty(items)) return null

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', flexWrap: 'wrap', gap: 1, justifyContent: 'center', my: 1 }}
    >
      {label && `${label}:`}
      {items.map(legend => (
        <Item key={legend.label} active {...legend} onClick={onChange} />
      ))}
    </Stack>
  )
}

export type LegendItem = {
  color: string
  label: string
  active?: boolean
}

type ItemProps = LegendItem & {
  onClick?: (legend: LegendItem) => void
}

const Item = (props: ItemProps) => {
  const { active: inital = true, label, onClick, ...rest } = props

  const theme = useTheme()

  const [active, setActive] = useState(inital)

  const handleClick = () => {
    setActive(!active)
    onClick?.({ ...props, active: !active })
  }

  const sx = !active
    ? { color: theme.palette.text.disabled, textDecoration: 'line-through' }
    : undefined

  return (
    <Stack
      direction="row"
      key={label}
      onClick={handleClick}
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        gap: 1,
      }}
    >
      <Dot {...rest} active={active} {...sx} />
      <Typography color="regular" sx={{ ...sx, userSelect: 'none' }}>
        {label}
      </Typography>
    </Stack>
  )
}

type DotProps = {
  color: string
  active?: boolean
}

const Dot = ({ color }: DotProps) => (
  <Box
    sx={{
      backgroundColor: color,
      borderRadius: '50%',
      height: 12,
      width: 12,
    }}
  />
)
